import Faq from "@/components/Faq.vue";
import { builderCta } from "@/helpers/builder-init/index";
import { useColors } from "@/helpers/composables/useColors";
const { colors } = useColors();
export const faqInit = {
    component: Faq,
    name: "Faqs",
    canHaveChildren: true,
    inputs: [
        {
            name: "headline",
            friendlyName: "Headline",
            type: "string",
            defaultVaue: "",
        },
        {
            name: "faqs",
            friendlyName: "FAQs",
            type: "list",
            subFields: [
                {
                    name: "question",
                    friendlyName: "Question",
                    type: "string",
                    defaultValue: "",
                },
                {
                    name: "answer",
                    friendlyName: "Answer",
                    type: "richText",
                },
            ],
        },
        {
            name: "cta",
            friendlyName: "CTA",
            type: "object",
            defaultValue: builderCta.defaultValue,
            subFields: [...builderCta.subFields]
        }
    ]
};
